import type { TOC } from '@ember/component/template-only';
import { concat, fn } from '@ember/helper';
import { PrismTooltip } from '@mylighthouse/prism-ember';
import { and } from 'ember-truth-helpers';
import type { ComparisonSet } from 'frontend-utils/utils/constants/benchmark-insight';
import GeneralChartsLegendsLegendItem from 'lumen/components/general/charts/legends/legend-item';
import HotelBenchmarkInsightChartsLegendItemsLegendInfoIconWithTooltip from 'lumen/components/hotel/benchmark-insight/charts/legend-items/legend-info-icon-with-tooltip';
import type { BreakdownPeriodType } from 'lumen/models/benchmark-insight/breakdown';
import type { HeroChartSeriesId } from 'lumen/utils/constants/benchmark-insight/beni-hero-chart-constant-values';
import type { PaceChartSeriesId } from 'lumen/utils/constants/benchmark-insight/beni-pace-chart-constant-values';

import styles from './legend-item.module.css';

export interface CustomLegend {
  breakdownPeriodType?: BreakdownPeriodType;
  comparisonSetType?: ComparisonSet;
  cssSelector: string;
  disabledTooltipText?: string;
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  id: HeroChartSeriesId | PaceChartSeriesId;
  infoTooltipContent?: {
    prefix: string;
    title: string;
  };
  isDisabled?: boolean;
  isDisabledForHiddenFutureCompsetData?: boolean;
  isDisabledForUnavailableComparisonSet?: boolean;
  isHidden: boolean;
  label: string;
  type: 'dot-large' | 'line';
}

interface HotelBenchmarkInsightChartsLegendItemsLegendItemSignature {
  Args: {
    legend: CustomLegend;
    toggleSeries: (chartSeriesId: HeroChartSeriesId) => void;
  };
}

const HotelBenchmarkInsightChartsLegendItemsLegendItem = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <GeneralChartsLegendsLegendItem
    @className={{concat
      styles.item
      " "
      (if @legend.isDisabled styles.item--disabled)
    }}
    @id={{@legend.cssSelector}}
    @isDisabled={{@legend.isDisabled}}
    @isHidden={{@legend.isHidden}}
    @legendItemClicked={{fn @toggleSeries @legend.id}}
    @type={{@legend.type}}
  >
    {{#if (and @legend.isDisabled @legend.disabledTooltipText)}}
      <PrismTooltip @text={{@legend.disabledTooltipText}} />
    {{/if}}

    <div class="flex items-center justify-center">
      {{@legend.label}}

      {{#if @legend.infoTooltipContent}}
        <div class="ml-100">
          <HotelBenchmarkInsightChartsLegendItemsLegendInfoIconWithTooltip
            @tooltipContent={{@legend.infoTooltipContent}}
          />
        </div>
      {{/if}}
    </div>
  </GeneralChartsLegendsLegendItem>
</template> satisfies TOC<HotelBenchmarkInsightChartsLegendItemsLegendItemSignature>;

export default HotelBenchmarkInsightChartsLegendItemsLegendItem;
